export default __webpack_public_path__ + "static/media/outdoor_poster_original.66f8f468.jpg";